import { gql } from "@apollo/client";

export const ALLOWED_FILE_EXTENSIONS_QUERY = gql`
  query allowedFileExtensions {
    allowedFileExtensions
  }
`;
